export default __webpack_public_path__ + "static/media/YellowPoint.d28c9320.svg";